export const Constants = {
    PAGE_ITEMS_PER_PAGE: 10,
    MIN_AGE: 18,
    MAX_AGE: 50,
} as const;
